import { useEffect, useState } from 'react';

// third party
import { useMsal } from '@azure/msal-react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { SWRConfig } from 'swr';

// project imports
import { STORAGE_AUTH_TOKEN } from 'constants/store';
import { AuthProvider } from 'context/authContext';
import { ManagedUIContext } from 'context/uiContext';
import Routes from 'routes';
import fetcher from 'services/utils/fetcher';
import { store } from 'store';

function App() {
    const { instance } = useMsal();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        instance
            .handleRedirectPromise()
            .then((response) => {
                setLoading(false);

                if (response && response.account) {
                    instance.setActiveAccount(response.account);
                    localStorage.setItem(STORAGE_AUTH_TOKEN, JSON.stringify(response.accessToken)); // response.accessToken
                    console.info('Redirect login successful:', response.account);
                    window.location.href = '/';
                } else {
                    const activeAccount = instance.getActiveAccount();
                    const accounts = instance.getAllAccounts();
                    if (!activeAccount && accounts.length > 0) {
                        instance.setActiveAccount(accounts[0]);
                    }
                    console.info('No redirect response found or already processed.');
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error handling redirect promise:', error);
            });
    }, [instance]);

    if (loading) return <>Loading...</>;

    return (
        <Provider store={store}>
            <HelmetProvider>
                <BrowserRouter>
                    <ManagedUIContext>
                        <SWRConfig
                            value={{
                                refreshInterval: 0,
                                revalidateOnFocus: false,
                                shouldRetryOnError: false,
                                fetcher,
                            }}
                        >
                            <AuthProvider>
                                <Routes />
                            </AuthProvider>
                        </SWRConfig>
                    </ManagedUIContext>
                </BrowserRouter>
            </HelmetProvider>
        </Provider>
    );
}

export default App;
